import { FC } from "react";
import { LinearProgress as MdLinearProgress } from "@rmwc/linear-progress";
import "@rmwc/linear-progress/styles";

export type LinearProgressTypes = {
  progress?: number;
  buffer?: number;
  closed?: boolean;
  reversed?: boolean;
};

const LinearProgress: FC<LinearProgressTypes> = (props) => {
  const { progress, buffer, closed, reversed } = props;

  return <MdLinearProgress progress={progress} buffer={buffer} closed={closed} reversed={reversed} />;
};

export default LinearProgress;
